import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';

@NgModule({
    imports: [CoreModule, RouterModule.forRoot([], { relativeLinkResolution: 'legacy' }), NgbModule],
    declarations: [AppComponent],
    bootstrap: [AppComponent],
})
export class AppModule {}
